import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(location.state?.user ? true : null);

  useEffect(() => {
    if (location.state?.user) return; // already verified via AuthCallback
    const checkAuth = async () => {
      try {
        const res = await fetch(`${API}/auth/me`, { credentials: "include" });
        if (!res.ok) throw new Error("Not authenticated");
        await res.json();
        setIsAuthenticated(true);
      } catch {
        setIsAuthenticated(false);
        navigate("/login", { replace: true });
      }
    };
    checkAuth();
  }, [location.state, navigate]);

  if (isAuthenticated === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0A2E2C] text-[#AEE6D5]">
        <p className="font-mono text-sm uppercase tracking-[0.22em]">Loading…</p>
      </div>
    );
  }
  return isAuthenticated ? children : null;
};
